export default __webpack_public_path__ + "static/media/Warlord's Band of Power.08bd2eae.jpg";